import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';

const URL_SCHEDULE = `${BASE_API}/health/schedule`;

const headers = () => ({
  Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
});

export const buscarDisponibilidade = (especialidade) =>
  axios
    .get(`${URL_SCHEDULE}/${especialidade}/availability`, {
      headers: headers(),
    })
    .then((r) => r.data);

export const buscarMeusAgendamentos = () =>
  axios
    .get(`${URL_SCHEDULE}/appointments`, { headers: headers() })
    .then((r) => r.data);

export const agendar = (especialidade, values) =>
  axios
    .post(`${URL_SCHEDULE}/${especialidade}/appointments`, values, {
      headers: headers(),
    })
    .then((r) => r.data);

export const cancelar = (especialidade, id) =>
  axios
    .post(
      `${URL_SCHEDULE}/${especialidade}/appointments/${id}/cancel`,
      {},
      { headers: headers() }
    )
    .then((r) => r.data);
